<template>
  <div class="Game">

<StepContainer :step="step">

    <CenterColumn>

      <h1>{{name}}</h1>

        <Step>
          <Instruction>
            <p>
              Good morning, we are glad that you have joined us at {{name}} 👏 We needed support. We work very quickly and effectively in the newspaper. If we miss a piece of news, we miss an opportunity. Grab your phones, tablets or computers. You will need to do some research and validation. It is imperative that we make sure we publish reliable content.
            </p>
            <p>
              Are you ready for the first scoope?
            </p>
          </Instruction>

          <ContinueButton @click.once="nextStep()">Yes!</ContinueButton>

        </Step>

        <Step v-if="randomCompetitor">
          <Instruction>
            We have a competitor, the news site <strong>{{randomCompetitor.name}}</strong> they write about the same news as we do! We have to be faster but still not make any errors. 
          </Instruction>

          <ContinueButton @click.once="nextStep()">Let's do it!</ContinueButton>

        </Step>
      </CenterColumn>

      <div v-for="(scoop,key) in scoops" :key="key">
        <Step>
          <hr />
          <ScoopTask :scoop="scoop"></ScoopTask>
        </Step>

        <br />

          <CenterColumn>

            <Step>
              <ScoopRating :scoop="scoop"></ScoopRating>
            </Step>

            <Step>
              <ScoopHeader :scoop="scoop"></ScoopHeader>
            </Step>

            <Step>
              <Instruction>
                {{getCommentHeader()}} Let's check your score.
              </Instruction>
              <ContinueButton @click.once="nextStep(); finishScoop(scoop)">Show Score!</ContinueButton>
            </Step>

            <Step>
              <Instruction :speech="false">
                <ScoopResult :scoop="scoop"></ScoopResult>
              </Instruction>

              <Instruction>
                Want to learn more about it? Or do you want to continue the game quickly?
              </Instruction>

              <ScoopMoreInfo :scoop="scoop"></ScoopMoreInfo>

              <div v-if="key+1 < scoops.length">
                <ContinueButton @click.once="nextStep()">Continue to the next story!</ContinueButton>
              </div>
              <div v-else>
                <ContinueButton @click.once="finish()">Show my final score!</ContinueButton>
              </div>
            </Step>
          </CenterColumn>


      </div>

      <Step>

        <hr />

        <CenterColumn>

          <GameResult></GameResult>
          <Instruction>
            Good work! Let's compare our result to our cometitors.
          </Instruction>
          <ContinueButton @click.once="nextStep()">Good idea!</ContinueButton>

        </CenterColumn>

      </Step>

      <br />

      <Step>
        <CenterColumn>
          <Highscore></Highscore>
          <Instruction>
            <p>
              Thank you for the work you did on {{name}}!
            </p>
            <p>
              If you want to learn more about how to rate the news and fact-checking, you can follow these links:
              <ul>
                <li>
                  <a href="https://www.snopes.com/" target="_blank">The fact checking site Snopes</a>
                </li>
                <li>
                  <a href="https://nathatshjalpen.se/a/source-criticism/" target="_blank">Make equal, a step by step guide to source criticism</a>
                </li>
              </ul>
            </p>
          </Instruction>

          <div class="sidebyside">
            <ContinueButton @click.once="restart()">Thank you!</ContinueButton>
             <ContinueButton @click.once="restart()">Bye!</ContinueButton>
          </div>
        </CenterColumn>
      </Step>

    </StepContainer>

  </div>
</template>

<script>

//import Vue from 'vue'

// @ is an alias to /src
import CenterColumn from '@/components/CenterColumn.vue'
import Instruction from '@/components/Instruction.vue'
//import Interactable from '@/components/Interactable.vue'
import ContinueButton from '@/components/ContinueButton.vue'
import StepContainer from '@/components/StepContainer.vue'
import Step from '@/components/Step.vue'
import ScoopTask from '@/components/ScoopTask.vue'
import ScoopRating from '@/components/ScoopRating.vue'
import ScoopResult from '@/components/ScoopResult.vue'
import ScoopHeader from '@/components/ScoopHeader.vue'
import ScoopMoreInfo from '@/components/ScoopMoreInfo.vue'
import GameResult from '@/components/GameResult.vue'
import Highscore from '@/components/Highscore.vue'

//import { createNamespacedHelpers } from 'vuex'
//const { mapState, mapGetters} = createNamespacedHelpers('newsroom')
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Game',
  components: {
    CenterColumn,
    Instruction,
    //Interactable,
    ContinueButton,
    StepContainer,
    Step,
    ScoopTask,
    ScoopRating,
    ScoopMoreInfo,
    ScoopResult,
    ScoopHeader,
    GameResult,
    Highscore
  },
  data: function () {
    return {
      //players: null
    }
  },
  computed: {
    ...mapState([
      'players'
    ]),
    ...mapState('newsroom',[
      'scoops',
      'step',
      'boss',
    ]),
    ...mapGetters([
      'getPlayer',
      'getCompetitors'
    ]),
    ...mapGetters('newsroom',[
      'calcPoints',
      'getNCorrect',
      'getTimeTotal',
      'getNCorrectRating'
    ]),
    ...mapGetters('newsroom/scoop',[
      'getCommentHeader'
    ]),
    name: {
      get () { return this.$store.state.newsroom.name},
      set (value) {
        this.$store.commit('newsroom/setName', {'name':value})
      }
    },
    randomCompetitor: function () {
      let nCompetitors = this.getCompetitors.length;
      if (nCompetitors > 0){
        return this.getCompetitors[Math.floor(Math.random() * nCompetitors)]
      }
      return null
    }
  },
  watch: {
  },
  methods: {
    nextStep: function () {
      this.$store.commit('newsroom/nextStep')
    },
    finishName: function () {
      //this.$refs['name'].setAttribute('disabled','disabled');
      this.nextStep()
    },
    finishScoop: function (scoop) {
      this.$store.commit('newsroom/scoop/setFinished', {scoop: scoop, finished: true})
    },
    finish: function () {
      this.$socket.emit('player update score', {
        score: this.calcPoints,
        time: this.getTimeTotal,
        correct: this.getNCorrect,
        rating: this.getNCorrectRating
      });
      this.$store.commit('newsroom/setFinished', {finished: true})
      this.nextStep()
    },
    restart: function () {
      this.$router.push({ name: 'Home'})
    },
    socketEvents: function (){
    }
  },
  created: function () {
    this.$store.dispatch('newsroom/initScoops')
  },
  mounted: function () {

    if(this.name == ""){
      this.$router.push({ name: 'Home'})
    }

    this.socketEvents();
    this.$socket.emit('player update name', this.name);
  },
}
</script>

<style lang="scss">

  .Game {
    flex: 1;
    flex-direction: column;
    display: flex;
    padding-bottom: 100px;
  }

</style>
